import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";
import Students from "../Settings/components/Students/index";
import FamilyMembers from "../Settings/components/FamilyMembers/index";
import TimetableConfiguration from "../TimetableConfiguration";
import Notification from "../Settings/components/Notification/index";
import Module from "../Settings/components/Module/index";
import Teachers from "../Settings/components/Teachers/index";
import Journal from "../Settings/components/Journal/index";
import AssessmentCategoriesWrapper from "../Settings/components/AssessmentCategoriesWrapper/index";
export default (store, isLearningCourseRoute = false) => ({
  path: !isLearningCourseRoute ? "class-settings" : "class-settings/:course_id",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "class-settings" */ "./components"),
        import(
          /* webpackChunkName: "class-settings" */ "../ManageFamily/modules/ManageFamilyModule"
        ),
        import(
          /* webpackChunkName: "class-settings" */ "../TimetableConfiguration/modules/TimetableConfigurationModule"
        ),
        import(
          /* webpackChunkName: "class-settings" */ "Administrator/modules/CommonModule"
        ),
        import(
          /* webpackChunkName: "class-settings" */ "CourseSetup/components/CreateCourse/containers/CreateCourseModule"
        ),
        import(
          /* webpackChunkName: "class-settings" */ "CourseSetup/components/EditCourse/containers/CourseDetailsModule"
        ),
        import(
          /* webpackChunkName: "class-settings" */ "CourseSetup/components/EditCourse/containers/CourseDetailsModule"
        ),
        import(
          /* webpackChunkName: "class-settings" */ "CourseSetup/modules/Module"
        ),
        import(
          /* webpackChunkName: "class-settings" */ "../Settings/modules/SettingsModule"
        ),
        import(
          /* webpackChunkName: "class-settings" */ "ResetInviteAndSignInCodeModal/modules/ResetInviteAndSignInCodeModalModule.js"
        ),
        import(
          /* webpackChunkName: "class-settings" */ "BulkActionsModal/modules/BulkActionsModalModule"
        ),
        import(
          /* webpackChunkName: "class-settings" */ "ManageStudents/modules/ManageStudentsModule"
        ),
      ]).then(
        ([
          importedModule0,
          importedModule1,
          importedModule2,
          importedModule3,
          importedModule4,
          importedModule5,
          importedModule6,
          importedModule7,
          importedModule8,
          importedModule9,
          importedModule10,
          importedModule11,
        ]) => {
          const component = importedModule0.default;
          const manageFamilyReducer = importedModule1.default;
          const timetableConfigurationReducer = importedModule2.default;
          const adminCommonReducer = importedModule3.default;
          const CreateCourseModule = importedModule4;
          const courseDetailsModule = importedModule5;
          const courseDetailsModuleReducer = importedModule6.default;
          const classSetupReducer = importedModule7.default;
          const classSetupReducerV2 = importedModule8.default;
          const resetInviteAndSignInCodeModalModule = importedModule9.default;
          const studentBulkActionsModule = importedModule10;
          const manageStudentsModule = importedModule11;

          injectReducer(store, {
            key: "manageFamily",
            reducer: manageFamilyReducer,
          });
          injectReducer(store, {
            key: "timetableConfiguration",
            reducer: timetableConfigurationReducer,
          });
          injectReducer(store, {
            key: "adminCommon",
            reducer: adminCommonReducer,
          });
          injectReducer(store, {
            key: CreateCourseModule.NAME,
            reducer: CreateCourseModule.default,
          });
          injectReducer(store, {
            key: courseDetailsModule.NAME,
            reducer: courseDetailsModule.default,
          });
          injectReducer(store, {
            key: "classDetails",
            reducer: courseDetailsModuleReducer,
          });
          injectReducer(store, {
            key: "classSetup",
            reducer: classSetupReducer,
          });
          injectReducer(store, {
            key: "classSettingsV2",
            reducer: classSetupReducerV2,
          });
          injectReducer(store, {
            key: "resetInviteAndSignInCodeModal",
            reducer: resetInviteAndSignInCodeModalModule,
          });
          injectReducer(store, {
            key: studentBulkActionsModule.NAME,
            reducer: studentBulkActionsModule.default,
          });
          injectReducer(store, {
            key: manageStudentsModule.NAME,
            reducer: manageStudentsModule.default,
          });
          return component;
        }
      )
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [
    Students(store),
    FamilyMembers(store),
    Notification(store),
    TimetableConfiguration(store),
    Module(store),
    Teachers(store),
    Journal(store),
    AssessmentCategoriesWrapper(store),
  ],
});
